import TopNav from '@/pages/home/components/TopNav';
import Hero from '@/pages/home/components/Hero';
import BoardIndex from '@/pages/home/components/BoardIndex';
import FocusWeekly from '@/pages/home/components/FocusWeekly';
import NewsFlash from '@/pages/home/components/NewsFlash';
import HotRanking from '@/pages/home/components/HotRanking';
import CommentBuzz from '@/pages/home/components/CommentBuzz';
import TrendTags from '@/pages/home/components/TrendTags';
import SiteFooter from '@/pages/home/components/SiteFooter';

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 overflow-x-hidden">
      <TopNav />
      <main className="w-full">
        <Hero />
        <BoardIndex />
        <FocusWeekly />
        <NewsFlash />
        <HotRanking />
        <CommentBuzz />
        <TrendTags />
      </main>
      <SiteFooter />
    </div>
  );
}